export default "__VITE_ASSET__WVO20XD___"